import { GITLAB_CREDITS_PLAN_TYPE } from '~/javascripts/subscription/constants';
import { __ } from '~/javascripts/lib/locale';

export const PURCHASE_DETAILS_STEP_ID = 'purchase_details';
export const CUSTOMER_DETAILS_STEP_ID = 'customer_details';
export const PAYMENT_DETAILS_STEP_ID = 'payment_details';
export const GITLAB_COM_DEPLOYMENT_TYPE = 'gitlab_com';
export const SELF_MANAGED_DEPLOYMENT_TYPE = 'self_managed';
export const BASE_PRODUCT_PLAN_TYPE = 'base_product';
export const PREMIUM_TIER = 'Premium';
export const PURCHASE_DETAILS_STEP = {
  id: PURCHASE_DETAILS_STEP_ID,
  title: __('Subscription details'),
};
export const CUSTOMER_DETAILS_STEP = {
  id: CUSTOMER_DETAILS_STEP_ID,
  title: __('Customer information'),
};
export const PAYMENT_DETAILS_STEP = {
  id: PAYMENT_DETAILS_STEP_ID,
  title: 'Payment method',
};

export const DEFAULT_PURCHASE_FLOW_STEPS = window.gon.global?.jh
  ? [PURCHASE_DETAILS_STEP]
  : [PURCHASE_DETAILS_STEP, CUSTOMER_DETAILS_STEP, PAYMENT_DETAILS_STEP];

export const PURCHASE_I18N = {
  [GITLAB_CREDITS_PLAN_TYPE]: {
    quantityLabelDescription: __('Credits that reset each month.'),
    quantityLabel: __('Monthly credits'),
    productName: __('GitLab credits'),
    unitLabel: __('credit'),
    pricePerUnitLabel: __('per credit per month (billed annually)'),
    gitlabCreditsSuccessMessage: __(
      'Your pool of GitLab Credits is active and will be used for GitLab Duo Agent Platform features going forward.',
    ),
  },
  [BASE_PRODUCT_PLAN_TYPE]: {
    quantityLabel: __('Seats'),
    unitLabel: __('seat'),
    pricePerUnitLabel: __('per seat per year'),
  },
};

export const CHARGE_TYPES = {
  RECURRING: 'Recurring',
  ONE_TIME: 'OneTime',
};
